import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  aboutContentSetIsLoadingReducerType,
  aboutContentSetDatabasesReducerType,
  aboutContentSetUpdateInfoReducerType,
  aboutContentSetBEBuildNumberReducerType,
} from './AboutContentConstants';

export const initialState = Map({
  BEBuildNumber: null,
  databases: null,
  updateInfo: null,
  isLoading: false,
});

const spec = {
  [aboutContentSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [aboutContentSetDatabasesReducerType]: (state, action) => {
    const { databases } = action.payload;
    return state.set('databases', databases);
  },
  [aboutContentSetUpdateInfoReducerType]: (state, action) => {
    const { updateInfo } = action.payload;
    return state.set('updateInfo', updateInfo);
  },
  [aboutContentSetBEBuildNumberReducerType]: (state, action) => {
    return state.set('BEBuildNumber', action.payload);
  },
};

export default createReducerBySpec(spec, initialState);
